import React from 'react';
import { Heading, Text, Flex, Semibold } from '@marvelapp/ui';
export function LayerListFilterEmptyState(_a) {
    var filterText = _a.filterText;
    return (React.createElement(Flex, { alignItems: "center", "data-testid": "layer-list-empty-filter", flexDirection: "column", height: "100%", justifyContent: "center", textAlign: "center" },
        React.createElement(Heading, { fontSize: 3, fontWeight: 500 }, "Try another search"),
        React.createElement(Text, { fontSize: 2, marginTop: 1 },
            "No layers matching ",
            React.createElement(Semibold, null, filterText))));
}
